import { ReactElement, useEffect } from 'react'
import { Box, Button, Chip, Typography } from '@mui/material'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import { TitleScreen } from 'src/v3/core/types'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import DangerousHtml from 'src/v3/components/dangerous-html'
import {
  selectCurrentStep,
  selectStreamItems,
  steppedForward,
  selectCourseID,
  selectCourseByID,
  selectCoursesStatus,
  fetchCourses,
  selectCourseAccreditationsByID,
  selectCourseAccreditationsStatus,
  fetchCourseAccreditations,
} from '../classroom.slice'

export default (): ReactElement => {
  let dispatch = useAppDispatch()

  let streamItems = useAppSelector(selectStreamItems)
  let currentStep = useAppSelector(selectCurrentStep)

  let courseID = useAppSelector(selectCourseID)
  let course = useAppSelector(selectCourseByID(courseID))
  let coursesStatus = useAppSelector(selectCoursesStatus)
  let courseAccreditations = useAppSelector(
    selectCourseAccreditationsByID(courseID),
  )
  let courseAccreditationsStatus = useAppSelector(
    selectCourseAccreditationsStatus,
  )

  let data = streamItems[currentStep] as TitleScreen

  useEffect(() => {
    if (coursesStatus === 'uninitialized') {
      dispatch(fetchCourses())
    }
  }, [coursesStatus])

  useEffect(() => {
    if (courseID && !courseAccreditationsStatus[courseID]) {
      dispatch(fetchCourseAccreditations(courseID))
    }
  }, [courseAccreditationsStatus, courseID])

  return (
    <div
      style={{
        backgroundImage: `url("${import.meta.env.VITE_CLOUDFRONT_URL}/public/${data?.imageName}")`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="p-4">
        <Typography sx={{ fontFamily: 'smileAndWave' }} variant="h4">
          {data?.name}
        </Typography>
        {!course?.linkedServiceID && (
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: 1,
              alignItems: 'center',
            }}
          >
            <Typography sx={{ mr: 1 }}>Accreditations:</Typography>
            {courseAccreditations?.length &&
              courseAccreditations?.map((a) => (
                <Chip key={a} label={a} variant="outlined" color="secondary" />
              ))}
          </Box>
        )}
        <Button
          size="large"
          variant="outlined"
          className="mt-5 bg-white"
          onClick={() => dispatch(steppedForward())}
        >
          <PlayArrowIcon color="primary" />{' '}
          <Typography color="primary">Play</Typography>
        </Button>
        <div className="mt-2">
          <DangerousHtml htmlVal={data?.content} isEncoded={true} />
        </div>
      </div>
    </div>
  )
}
